import React from "react";
import { View } from "@data-root/react";

export const VisionView = () => {
  return (
    <View
      style={{
        height: "100%",
        width: "100%",
        backgroundColor: "#ddd",
        overflow: "hidden",
      }}
    ></View>
  );
};
